import React, { useEffect, useState, useMemo } from 'react';
import { translate } from '@utils/i18n';
import './TechnicianModal.scss';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ui/molecules/Modal';
import { Button } from '@ui';
import { Table, TableSize } from '@ui/molecules/Table';
const namespace = 'features.settings.ai_inspection_manager';
const COLUMNS = [{ dataKey: 'name', label: translate('column_title', { namespace }) }];
function TechnicianModal({ isModalOpen, onClose, initialTechnicians, onSave }) {
    const [search, setSearch] = useState('');
    const [technicians, setTechnicians] = useState(initialTechnicians);
    const selectedIds = useMemo(() => technicians.filter((t) => t.enabled).map((t) => t.id), [technicians]);
    const selectedTechniciansCount = selectedIds.length;
    const isSelect = selectedTechniciansCount === 0;
    const handleSelectionChange = (itemId, checked) => {
        setTechnicians((prev) => prev.map((t) => (t.id === itemId ? Object.assign(Object.assign({}, t), { enabled: checked }) : t)));
    };
    const handleSelectAll = (selectAll) => {
        setTechnicians((prev) => prev.map((t) => (Object.assign(Object.assign({}, t), { enabled: selectAll }))));
    };
    const handleSave = () => {
        onSave(technicians);
        onClose();
    };
    useEffect(() => {
        setSearch('');
    }, [isModalOpen]);
    const onSearchChange = (event) => {
        setSearch(event.target.value);
    };
    const techniciansFiltered = useMemo(() => {
        if (search === '')
            return technicians;
        const re = new RegExp(search, 'i');
        return technicians.filter((t) => re.test(t.name));
    }, [search, technicians]);
    const title = translate('manage_technicians', { namespace });
    const buttonText = isSelect
        ? translate('add_technicians', { namespace })
        : translate('update_technicians', { namespace });
    return (React.createElement(Modal, { isOpen: isModalOpen, onClose: onClose, ariaLabelledBy: "technician-modal-title", className: "technician-modal" },
        React.createElement(ModalHeader, { title: title, titleId: "technician-modal-title", onClose: onClose }),
        React.createElement(ModalBody, null,
            React.createElement("p", { className: "technician-modal__description" }, translate('technician_modal_description', { namespace })),
            React.createElement("div", { className: "qmb-input--search", style: { width: '200px', marginBottom: '20px', zIndex: 0 } },
                React.createElement("input", { placeholder: translate('search', { namespace: 'generic' }), id: "search", value: search, onChange: onSearchChange }),
                React.createElement("i", { className: "fa-light fa-search", "aria-hidden": "true" })),
            React.createElement(Table, { data: techniciansFiltered, columns: COLUMNS, size: TableSize.Full, variant: "detail", selectable: true, selectedItems: selectedIds, onSelectionChange: handleSelectionChange, onSelectAll: handleSelectAll, getItemId: (item) => item.id }),
            techniciansFiltered.length === 0 && (React.createElement("section", { className: "noResulsContainer" }, translate('no_matches_found', { namespace: 'features.commons' })))),
        React.createElement(ModalFooter, { startActions: React.createElement("span", null,
                selectedTechniciansCount,
                " ",
                translate('selected', { namespace })) },
            React.createElement("button", { type: "button", className: "qmb-control", onClick: onClose }, translate('cancel', { namespace: 'generic' })),
            React.createElement(Button, { variant: "primary", onClick: handleSave, disabled: selectedTechniciansCount === 0 }, buttonText))));
}
export default TechnicianModal;
